
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import getBackendUrl from "../../../environment/BackendService";
import { downloadCSV,fetchDataCallOnInitialLoad } from "../../../common_nextgen/utils/UtilFunctions";

const usePriceEdgeSchedule = () => {
    const { axios_helper_no_header } = useAxios();
    const [data, setData] = useState([]); /* Price Schedule Data */
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [totalRecords, setTotalRecords] = useState(0);
    const [rowData, setRowData] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [selectedRows, setSelectedRows] = useState([]);
    const navigateToPage = useCustomNavigate();
    const [dropdownValues, setDropdownValues] = useState({});
    const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState("no");
    const toast = useToast();
    const location = useLocation();
    const { ADD_PRICE_EDGE_SCHEDULE, EDIT_PRICE_EDGE_SCHEDULE, DISPLAY_PRICE_EDGE_SCHEDULE, COPY_PRICE_EDGE_SCHEDULE, PRICE_EDGE_SCHEDULE_NOTE, PRICE_EDGE_SCHEDULE_SEQUENCE } = ROUTE_PATHS;

    const [isHideConfirmationModalOpen, setIsHideConfirmationModalOpen] = useState(false);
    const [lookupType, setLookupType] = useState("");
    const [selectParams, setSelectParams] = useState([]);
    const [selectMode, setSelectMode] = useState(false);
    const openHideConfirmationModal = () => setIsHideConfirmationModalOpen(true);

    const screen_title = "Price Edge Schedule";
    const [screenNumber, setScreenNumber] = useState("RCPES001");
    const [externalScreenNumber, setExternalScreenNumber] = useState("");

    const stateVal = location.state ?? [];
    const [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
  
    const {
      selectedPatients = [],
      previousScreen = "",
      currentIndex: initialIndex = 0,
      paramsData: initialParamsData = {
        pesScheduleName: "",    
      },
    } = currentState;

    const [currentIndex, setCurrentIndex] = useState(initialIndex);
    const [paramsData, setParamsData] = useState(initialParamsData);
 
    const selectedSchedulesData = selectedRows.length ? selectedRows : [rowData];
    const lastScheduleName =
      selectedSchedulesData[selectedSchedulesData.length - 1]?.pesScheduleName;
    const updatedParamsData = {
      ...paramsData,
      pesScheduleName: lastScheduleName,
    };

    useEffect(() => {
        if (selectMode) {
          setScreenNumber(externalScreenNumber || "RCPES004");
        }
      }, [selectMode, externalScreenNumber]);
    
    /* Search form fields that needs to be shown for filtering */
    const formFields = [
        {
            fieldLabel: "PES Schedule Name",
            name: "pesScheduleName",
            label: "Schedule",
            type: "text",
            fieldNature: "editable",
            value: "",
            maxLength: 10,
        },
    ];

    /* Dropdown options fields that needs to be fetched with API */
    const dropdownOptions = [];

    const dropdownCondition = {
        dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
    };

    const leftButtons = selectMode ? [{
        button_label: "Back",
        button_handeler: () => {
          if (lookupType === "external") {
            const message = { type: "hideModal" };
            window.parent.postMessage(message, "*");
          }
        },
        button_key: "F12",
      }] : [];

    /* ACTION BUTTONS info that needs to be displayed on the page */
    const ctaButtons = [
        ...(!selectMode &&
        [{
            button_label: "Add Price Edge Schedule",
            button_handeler: () => {
                navigateToPage(ADD_PRICE_EDGE_SCHEDULE, [
                    {
                        previousScreen: location.pathname,
                    },
                ]);
            },
            button_key: "F6",
        }] || []),
        {
            button_label: "Export as CSV",
            button_handeler: () => {
                exportAsCSV();
            },
            button_key: "",
        },
    ];

    /* Gear Icon Menu option CTAs */
    const menuOptions = [  
        ...(selectMode  
          ? [  
              {  
                label: "Select",  
                icon: <span className="material-icons">add</span>,  
                command: async () => {  
                  try {  
                    const paramDataMap = new Map();
                    selectParams.forEach((key) => {
                    if (rowData.hasOwnProperty(key["target"])) {
                        paramDataMap.set(key["source"], rowData[key["target"]]);
                        }
                    });
                    const paramData = Object.fromEntries(paramDataMap);
                    if (lookupType === "external") {  
                      const message = {  
                        type: "responseData",  
                        data: paramData,  
                      };  
                      window.parent.postMessage(message, "*");  
                    }  
                  } catch (error) {  
                    console.error(error);  
                  }  
                }  
              } ,
              {  
                label: "Display",  
                icon: <span className="material-icons">visibility</span>,  
                command: () => {   
                  if (lookupType === "external") {
                    const message = {
                      type: "navigateData",
                      data: { ...rowData },
                      target: "PRICE_EDGE_SCHEDULE_READ_ONLY",
                     // schedulesDataKey: "selectedPriceEdge",
                    };
                    console.log("display message", message);
                    window.parent?.postMessage(message, "*");
                  }
                }  
              } ,
              {  
                label: "Sequences",  
                icon: <span className="material-icons">list</span>,  
                command: () => {  
                  if (lookupType === "external") {
                    const message = {
                      type: "navigateData",
                      data: { ...rowData },
                      target: "PRICE_EDGE_SCHEDULE_SEQUENCE",
                     // schedulesDataKey: "selectedPriceEdge",
                    };
                    console.log("display message", message);
                    window.parent?.postMessage(message, "*");
                  } 
                }  
              }  
            ]  
          : [  
              {  
                label: "Note",  
                icon: <span className="material-icons">note</span>,  
                command: () => {  
                  navigateToPage(PRICE_EDGE_SCHEDULE_NOTE, [  
                    {  
                      ...currentState,  
                      paramsData: updatedParamsData,  
                      currentIndex: currentIndex,  
                    },  
                    {  
                      selectedPriceEdge: selectedRows.length ? selectedRows : [rowData],  
                      previousScreen: location.pathname,  
                    }  
                  ]);  
                }  
              },  
              {  
                label: "Edit",  
                icon: <span className="material-icons">edit</span>,  
                command: () => {  
                  navigateToPage(EDIT_PRICE_EDGE_SCHEDULE, [  
                    {  
                      ...currentState,  
                      paramsData: updatedParamsData,  
                      currentIndex: currentIndex,  
                    },  
                    {  
                      selectedPriceEdge: selectedRows.length ? selectedRows : [rowData],  
                      previousScreen: location.pathname,  
                    }  
                  ]);  
                }  
              },  
              {  
                label: "Copy",  
                icon: <span className="material-icons">content_copy</span>,  
                command: () => {  
                  navigateToPage(COPY_PRICE_EDGE_SCHEDULE, [  
                    {  
                      ...currentState,  
                      paramsData: updatedParamsData,  
                      currentIndex: currentIndex,  
                    },  
                    {  
                      selectedPriceSchedules: selectedRows.length ? selectedRows : [rowData],  
                      previousScreen: location.pathname,  
                    }  
                  ]);  
                }  
              },  
              {  
                label: "Delete",  
                icon: <span className="material-icons">delete</span>,  
                command: () => {  
                  openConfirmationModal();  
                }  
              },  
              {  
                label: "Display",  
                icon: <span className="material-icons">visibility</span>,  
                command: () => {  
                  navigateToPage(DISPLAY_PRICE_EDGE_SCHEDULE, [  
                    {  
                      ...currentState,  
                      paramsData: updatedParamsData,  
                      currentIndex: currentIndex,  
                    },  
                    {  
                      selectedPriceEdge: selectedRows.length ? selectedRows : [rowData],  
                      previousScreen: location.pathname,  
                    }  
                  ]);  
                }  
              } ,
              {  
                label: "Sequences",  
                icon: <span className="material-icons">list</span>,  
                command: () => {  
                  navigateToPage(PRICE_EDGE_SCHEDULE_SEQUENCE, [  
                    {  
                      ...currentState,  
                      paramsData: updatedParamsData,  
                      currentIndex: currentIndex,  
                    },  
                    {  
                      selectedSchedules: selectedRows.length ? selectedRows : [rowData],  
                      previousScreen: location.pathname,  
                      currentIndex: 0,  
                    },  
                  ]);  
                }  
              }   
            ]  
        ),  
      ];  

    /* Data table column info. */
    const columnDef = [
        {
            header: "Schedule",
            field: "pesScheduleName",
        },
        {
            header: "Description",
            field: "pesScheduleDescription",
        },
        {
            header: "Process Flag",
            field: "pesProcessFlag",
        },
    ];

    /* Param Key which used as bridge between various operations on tabluar data */
    const parmKey = "pesScheduleName";

    /* Handler that fetches the data */
    const fetchData = async () => {
        console.log("fetch data");
        const page = first / rows;
        try {
            const raw_response = await axios_helper_no_header(
                "GET",
                `api/pesPriceEdgeSchedule`,
                null,
                {
                    page: page,
                    size: rows,
                    ...paramsData,
                }
            );
            const response = raw_response.responseData;
            const pageResponse = raw_response.responsePaginationDTO;
            if (response.length === 0) {
                setData([]);
                setTotalRecords(0);
                console.log("response.length is ", response.length);
                toast.current.show({
                    severity: "info",
                    summary: "",
                    detail: response.responseStatus.message,
                    life: 3000,
                });
            } else {
                setData(response);
                console.log("response", response);
                console.log(pageResponse.totalRecords);
                setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords  
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            setData([]);
            setTotalRecords(0);
        }
    };

    const fetchDropdownData = async (dataDropdown) => {
        try {
            const response = await fetchDropdownValues(dataDropdown);
            setDropdownValues(response);
        } catch (error) {
            console.error("Error fetching dropdown values:", error);
        }
    };

    useEffect(() => {
        fetchDropdownData(dropdownCondition);
    }, []);

    useEffect(() => {
      fetchDataCallOnInitialLoad(fetchData, lookupType); // Initial fetch with page 0 and page size 10  
    }, [paramsData, rows, currentPage, lookupType]);

    const onPageChange = (event) => {
        console.log("page change", event.first, event);
        setFirst(event.first);
        setCurrentPage(event.page);
        setRows(event.rows);
    };

    const openConfirmationModal = () => {
        setIsConfirmationModalOpen(true);
    };

    const closeConfirmationModal = () => {
        console.log(selectedOption);
        setIsConfirmationModalOpen(false);
        setSelectedOption("no");
    };

    const deletePriceEdgeSchedule = () => {
        if (selectedOption === "yes") {
            let priceEdgeScheduleList = [];
            if (Array.isArray(selectedRows) && selectedRows.length > 0) {
                priceEdgeScheduleList = selectedRows.map((row) => 
                     row.pesScheduleName);
              } else if (rowData && Object.keys(rowData).length > 0) {
                priceEdgeScheduleList[0] = rowData.pesScheduleName;
              }
              if (priceEdgeScheduleList.length > 0) {
          //  const params = { priceEdgeScheduleName: rowData[parmKey] };
            axios_helper_no_header("DELETE", "api/pesPriceEdgeSchedule", priceEdgeScheduleList, null)
                .then((response) => {
                    const updatedItems = data.filter((item) => item[parmKey] !== rowData);
                    setTotalRecords((prevTotal) => prevTotal - 1);
                    setData(updatedItems);
                    fetchData();
                    toast.current.show({
                        severity: "success",
                        summary: "",
                        detail: response.responseStatus.message,
                        life: 3000,
                    });
                    closeConfirmationModal();
                })
                .catch((error) => {
                    console.error("There was an error deleting the data!", error);
                    const errorMessage =
                        error.data?.responseStatus?.message || error.message;
                    toast.current.show({
                        severity: "error",
                        summary: "",
                        detail: errorMessage,
                        life: 3000,
                    });
                    closeConfirmationModal();
                });
        } 
    }else {
            closeConfirmationModal();
        }
    };

    const exportAsCSV = async () => {
        const queryParams = new URLSearchParams({ ...paramsData, screenNumber });
    
        try {
          const response = await axios_helper_no_header(
            "GET",
            "api/pesPriceEdgeSchedule/exportCsv",
            null,
            queryParams,
            "blob"
          );
          downloadCSV(response);
        } catch (error) {
          console.error("Error exporting as CSV:", error);
          toast.current.show({
            severity: "error",
            summary: "",
            detail: "Failed to export CSV. Please try again.",
            life: 3000,
          });
        }
      };

    const updateParamData = (data) => {
        setFirst(0);
        setCurrentPage(0);
        setParamsData(data);
    };

    const handleMessage = (event) => {
        const { type, data } = event.data;
        console.log("iframe load", type, data);
        if (type === "initData") {
          const { selectMode, data: paramData } = data;
          console.log("external data", paramData, selectMode);
          setLookupType("external");
          setSelectParams(paramData.params);
          setParamsData(paramData.paramsData);
          setSelectMode(selectMode);
          if (paramData?.screenNumber) {
            setExternalScreenNumber(paramData?.screenNumber);
          }
        }
        console.log("message", event.data);
      };
    
      useEffect(() => {
        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
      });

    return {
        screenNumber,
        screen_title,
        formFields,
        dropdownValues,
        paramsData,
        updateParamData,
        ctaButtons,
        data,
        parmKey,
        menuOptions,
        columnDef,
        setRowData,
        selectedRows,
        setSelectedRows,
        first,
        rows,
        totalRecords,
        currentPage,
        onPageChange,
        isConfirmationModalOpen,
        closeConfirmationModal,
        deletePriceEdgeSchedule,
        setSelectedOption,
        selectMode,
        leftButtons
    };
};

export default usePriceEdgeSchedule;  